import { createContext, type ReactNode, useState } from "react";
import type { ChatsContextType, StateType } from "./type";

export const ChatsContext = createContext<ChatsContextType | null>(null);

type ProviderProps = {
  children: ReactNode;
};

export const Provider = ({ children }: ProviderProps) => {
  const [state, setState] = useState<StateType>("default");

  return (
    <ChatsContext.Provider value={{ state, setState }}>
      {children}
    </ChatsContext.Provider>
  );
};